import React from "react"
import { onlyDigitsAndSlashWithMaxLen, onlyDigitsWithMaxLen } from "./helper"
import { TextField, useTheme, alpha, InputAdornment } from "@mui/material"

export function NumberTextField(props) {
  const {
    register,
    isRequired = true,
    maxLength = 10,
    minLength = 0,
    label,
    name,
    min = 0,
    max = Number.MAX_VALUE,
    icon,
    chequeAmountTemp,
    formatType="numbers",
    type="text",
    ...etc
  } = props
  const inputRules = getInputRules(props)
  const theme = useTheme()

  const elementProps = {
    inputProps: { maxLength },
    InputProps: {
      maxLength: maxLength
    },
    name,
    fullWidth: true,
    label: label || "",
    type: type,
    sx: {
      caretColor: theme.palette.secondary.main,
      borderRadius: "8px"
    },
    style: {
      backgroundColor: alpha(theme.palette.grey[200], 0.5)
    }
  }
  if (icon) {
    const Icon = icon
    elementProps.InputProps.endAdornment = (
      <InputAdornment position='start'>
        <Icon size={20} color={theme.palette.primary.dark} />
      </InputAdornment>
    )
  }
  if (maxLength) {
    if (formatType === "numbers") elementProps.onKeyDown = onlyDigitsWithMaxLen(maxLength)
    if (formatType === "numbers-slash") elementProps.onKeyDown = onlyDigitsAndSlashWithMaxLen(maxLength)
  }

  return <TextField value={chequeAmountTemp} {...elementProps} {...register(name, inputRules)} {...etc} />
}

export function getInputRules(props) {
  const {
    register,
    isRequired = true,
    maxLength = 10,
    minLength = 0,
    label,
    name,
    min = 0,
    max = Number.MAX_VALUE,
    ...etc
  } = props
  const lbl = label || ""
  let minLengthMsg = `${lbl} حداقل باید ${minLength} رقم باشد.`
  let maxLengthMsg = `${lbl} حداکثر باید ${maxLength} رقم باشد.`
  let minMsg = `${lbl} نمیتواند کمتر از ${min} باشد.`
  let maxMsg = `${lbl} نمیتواند بیشتر از ${max} باشد.`
  if (minLength === maxLength) {
    minLengthMsg = maxLengthMsg = `${lbl} باید ${minLength} رقم باشد.`
  }
  const rules = {
    maxLength: { value: maxLength, message: maxLengthMsg }
  }
  if (isRequired) rules.required = lbl + " اجباری است"
  if (minLength) rules.minLength = { value: minLength, message: minLengthMsg }
  if (min) rules.min = { value: min, message: minMsg }
  if (max !== Number.MAX_VALUE) rules.max = { value: max, message: maxMsg }
  return rules
}
